<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="Reportes">
        <el-tabs :tab-position="tabPosition" style="height: 690px">
          <el-tab-pane label="SIMS">
            <ReportNavision />
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="Solicitudes de Soporte Tecnico">
        <SoliSoporteTecni />
      </el-tab-pane>
      <el-tab-pane label="Solicitudes por asignados">
        <SoliForAsig />
      </el-tab-pane>
      <el-tab-pane label="Clientes (Navixy) a cortar">
        <ReportUsersToCut />
      </el-tab-pane>
      <el-tab-pane label="Reporte Mantenimiento de CHIP">
        <ReporMChip />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReportNavision from "@/views/modules/technical_support/reports/ReportNavision";
import SoliSoporteTecni from "@/views/modules/technical_support/reports/ReportByRequest.vue";
import SoliForAsig from "@/views/modules/technical_support/reports/ReportRequestByTechnical.vue";
import ReportUsersToCut from "@/views/modules/technical_support/reports/ReportUsersToCut";
import ReporMChip from "@/views/modules/technical_support/reports/ReportMaintenanceChip.vue";
export default {
  data() {
    return {
      tabPosition: "left"
    };
  },
  components: {
    ReportNavision,
    SoliSoporteTecni,
    SoliForAsig,
    ReportUsersToCut,
    ReporMChip
  }
};
</script>

<style></style>
